import React, { useEffect, useState } from 'react'
import { Col, Row, Alert } from 'reactstrap'
import { Controller, ErrorMessage, useFormContext } from 'react-hook-form'
import { useFormUtils } from 'views/shared/useFormUtils'
import Select from 'react-select'
import {
  containerSizeOptionsDefault,
  wholeContainerSizeOptions,
  lactoseContainerSizeOptions,
  evaporatedContainerSizeOptions,
  milkTypeOptions,
} from './constants'
import PropTypes from 'prop-types'

const WholeMilkPackageReview = ({ item, isDisabled }) => {
  const [packaging, setPackaging] = useState({
    fkCategory: item.fkCategory,
    fkSubCategory: item.fkSubCategory,
    WholeMilkType: item.WholeMilkType,
    WholeMilkSize: item.WholeMilkSize,
  })

  const [containerSizeOptions, setContainerSizeOptions] = useState(
    containerSizeOptionsDefault
  )

  const setContainerSize = () => {
    if (item.WholeMilkType === 'Whole') {
      setContainerSizeOptions(wholeContainerSizeOptions)
    } else if (item.WholeMilkType === 'Whole Lactose Free') {
      setContainerSizeOptions(lactoseContainerSizeOptions)
    } else if (item.WholeMilkType === 'Whole Evaporated') {
      setContainerSizeOptions(evaporatedContainerSizeOptions)
    }
  }

  const containerSizeReset = () => {
    methods.reset(
      { WholeMilkSize: '' },
      {
        errors: false, // errors will not be reset
        dirtyFields: false, // dirtyFields will not be reset
        dirty: false, // dirty will not be reset
        isSubmitted: false,
        touched: false,
        isValid: false,
        submitCount: false,
      }
    )
  }

  const methods = useFormContext()
  const { setSelectReviewer, asterisk } = useFormUtils()
  useEffect(() => {
    if (item !== null) {
      const { WholeMilkType, WholeMilkSize } = item
      setPackaging({
        WholeMilkType,
        WholeMilkSize,
      })
      setContainerSize()
    }
    // eslint-disable-next-line
    }, [item])

  return (
    <Row>
      <Col xs={6}>
        <h6>Milk Type {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={milkTypeOptions}
          defaultValue={{
            label: packaging.WholeMilkType,
            value: packaging.WholeMilkType,
          }}
          name="WholeMilkType"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Milk Type'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            containerSizeReset()
            setContainerSize()
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="WholeMilkType"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
        <br />
        <h6>Size {asterisk}</h6>
        <Controller
          as={Select}
          className="react-select primary"
          classNamePrefix="react-select"
          options={containerSizeOptions}
          defaultValue={{
            label: packaging.WholeMilkSize,
            value: packaging.WholeMilkSize,
          }}
          name="WholeMilkSize"
          control={methods.control}
          rules={{ required: true }}
          placeholder={'Select Size'}
          onChange={([selected, value]) => {
            setSelectReviewer(item, selected, value)
            return selected
          }}
          isDisabled={isDisabled}
        />
        <p className={'text-danger'}>
          <ErrorMessage
            errors={methods.errors}
            name="WholeMilkSize"
            message={'⚠ This selection is required.'}
            as={<Alert color={'danger'} className={'mt-3'} />}
          />
        </p>
      </Col>
    </Row>
  )
}

WholeMilkPackageReview.propTypes = {
  item: PropTypes.object,
  isDisabled: PropTypes.bool,
}

export default WholeMilkPackageReview
